<div class="chart-wrapper">
	<div #LegendWrapper class="chart-legend-container"></div>
	<div class="chart-body-container">
		<canvas #ChartItem class="chart-body"></canvas>
	</div>
</div>